import React from "react";

const WaveBackground = () => (
  <div className="waves" aria-hidden="true">
    <span className="waves__layer waves__layer--back" />
    <span className="waves__layer waves__layer--middle" />
    <span className="waves__layer waves__layer--front" />
  </div>
);

export default WaveBackground;
